import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../../../utils/common.constants';

@Injectable()
export class AddHospitalizationService { 

  constructor(private http: HttpClient) { }
 
  getFileData(fileId, services): Observable<any> {
    return this.http.get(CommonConstants.env +'api/medicalFile/' + fileId + '?services=' + services.toString()).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  savePlan(data) {
    return this.http.post(CommonConstants.env +'api/medicalFile/hospitalization', data).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveAdmission(data) { 
    return this.http.post(CommonConstants.env +'api/medicalFile/hosp/admission', data).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveExamAdmission(data) {
    return this.http.post(CommonConstants.env +'api/medicalFile/hosp/admission/exam', data).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveOperatingRoom(data) {
    return this.http.post(CommonConstants.env +'api/medicalFile/hosp/surgery', data).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveOperativeReport(data) {
    return this.http.post(CommonConstants.env +'api/medicalFile/hosp/surgery/report', data).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveHospReport(data) {
    return this.http.post(CommonConstants.env +'api/medicalFile/hosp/report', data).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveMedicalReport(data) {
    return this.http.post(CommonConstants.env +'api/medicalFile/hosp/medical/report', data).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  errorHandler(error: any): void {
    throwError(error);
  };

  getHardCodedData() { 

    return of(
      {
      
        "code": "S0000",
      
        "message": "Total 1 records found",
      
        "result": {
      
          "MED_HOSP_ADMISSION": [
      
            {
      
              "createdTime": "17-09-2020 19:40",
      
              "modifiedTime": "17-09-2020 19:40",
      
              "createdUser": "Super",
      
              "modifiedUser": "Super",
      
              "medhpId": 3,
      
              "bedTypeAdmiss": "str",
      
              "medhpDtAdmissionDate": null,
      
              "medhpVaAdmissionComment": "string",
      
              "medhpVaAdmissionDoctor": "string",
      
              "medhpVaAdmissionFloor": "string",
      
              "medhpVaAdmissionReceptionNurse": "string",
      
              "medhpVaAdmissionRoom": "string",
      
              "medhpVaAdmissionTel": "string",
      
              "medhpVaAdmissionTelNurse": "string",
      
              "medhpVaAdmissionTelPatient": "string",
      
              "medhpVaAdmissionUnit": "string",
      
              "medhpVaCode": "string",
      
              "spltyIdAdmiss": 5,
      
              "staRecCode": "A",
      
              "medfiId": null
      
            }
      
          ],
      
          "MED_HOSP_SURGERY": [
      
            {
      
              "createdTime": "17-09-2020 20:30",
      
              "modifiedTime": "17-09-2020 20:30",
      
              "createdUser": "Super",
      
              "modifiedUser": "Super",
      
              "medhpId": 3,
      
              "medhpOperaAids": "string",
      
              "medhpOperaAnesthetist": "string",
      
              "medhpOperaBlockouttime": "string",
      
              "medhpOperaByairplaneexitplanned": "string",
      
              "medhpOperaDateandhour": "10-09-2020 13:23",
      
              "medhpOperaDestinationplanned": "string",
      
              "medhpOperaEndtime": "string",
      
              "medhpOperaExitplanned": "string",
      
              "medhpOperaNote": "string",
      
              "medhpOperaNurseroom": "string",
      
              "medhpOperaOperator": "string",
      
              "medhpOperaPerformedbycro": "string",
      
              "medhpOperaPreopdiagnosis": "string",
      
              "medhpOperaRecord": "string",
      
              "medhpOperaStarttime": "string",
      
              "medhpOperaSurgicaldiagnosis": "string",
      
              "medhpOperaTransferto": "string",
      
              "staRecCode": "string",
      
              "medfiId": null
      
            }
      
          ],
      
          "MED_HOSP_REPORT": [
      
            {
      
              "createdTime": "17-09-2020 20:27",
      
              "modifiedTime": "17-09-2020 20:27",
      
              "createdUser": "Super",
      
              "modifiedUser": "Super",
      
              "medhpDtHospReportDate": "10-09-2020 13:34",
      
              "medhpDtHospReportEffectiveExitdate": "10-09-2020 13:34",
      
              "medhpDtHospReportIntialExitDate": "10-09-2020 13:34",
      
              "medhpDtHospReportNextAppointmentDate": "10-09-2020 13:34",
      
              "medhpEnHospReportInitialDestination": "str",
      
              "medhpEnHospReportReportDestination": 0,
      
              "medhpId": 3,
      
              "medhpVaHospReportAppointmentWithDoctor": "string",
      
              "medhpVaHospReportBloodpressure": "string",
      
              "medhpVaHospReportDoctor": "string",
      
              "medhpVaHospReportExam": "string",
      
              "medhpVaHospReportFinalDiagnostic": "string",
      
              "medhpVaHospReportHeight": "string",
      
              "medhpVaHospReportIma": "string",
      
              "medhpVaHospReportPulse": "string",
      
              "medhpVaHospReportReport": "string",
      
              "medhpVaHospReportService": "string",
      
              "medhpVaHospReportTemperature": "string",
      
              "medhpVaHospReportWeight": "string",
      
              "patcoIdHospReport": null,
      
              "staRecCode": "string",
      
              "medfiId": null
      
            }
      
          ],
      
          "MED_HOSP_ADMISSION_EXAM": [
      
            {
      
              "createdTime": "17-09-2020 19:48",
      
              "modifiedTime": "17-09-2020 19:48",
      
              "createdUser": "Super",
      
              "modifiedUser": "Super",
      
              "envExtPlId": "str",
      
              "envTraId": "str",
      
              "envTraStopWorkingAgain": "str",
      
              "medhpDtExamAdmissionDate": "18-09-2020 21:09",
      
              "medhpDtExamAdmissionDurationDate": "18-09-2020 21:09",
      
              "medhpDtExamAdmissionExit": "18-09-2020 21:09",
      
              "medhpId": 3,
      
              "medhpNuExamAdmissionDuration": 0,
      
              "medhpVaExamAdmissionBloodPressure": "string",
      
              "medhpVaExamAdmissionComment": "string",
      
              "medhpVaExamAdmissionDiagnostic": "string",
      
              "medhpVaExamAdmissionDoctor": "string",
      
              "medhpVaExamAdmissionExam": "string",
      
              "medhpVaExamAdmissionHeight": "string",
      
              "medhpVaExamAdmissionIma": "string",
      
              "medhpVaExamAdmissionPulse": "string",
      
              "medhpVaExamAdmissionService": "string",
      
              "medhpVaExamAdmissionTemperature": "string",
      
              "medhpVaExamAdmissionWeight": "string",
      
              "patcoIdExamAdmission": 0,
      
              "staRecCode": "A",
      
              "medfiId": null
      
            }
      
          ],
      
          "MED_HSOP_MEDICAL_REPORT": [
      
            {
      
              "createdTime": "17-09-2020 20:16",
      
              "modifiedTime": "17-09-2020 20:16",
      
              "createdUser": "Super",
      
              "modifiedUser": "Super",
      
              "medhpDtReportDate": "18-09-2020 10:12",
      
              "medhpDtReportExitDatetime": "18-09-2020 10:12",
      
              "medhpId": 3,
      
              "medhpVaReportBmi": "string",
      
              "medhpVaReportBp": "string",
      
              "medhpVaReportComment": "string",
      
              "medhpVaReportDoctor": "string",
      
              "medhpVaReportEntry": "string",
      
              "medhpVaReportEntryDiagnostic": "string",
      
              "medhpVaReportImmediateResult": "string",
      
              "medhpVaReportPouls": "string",
      
              "medhpVaReportProcedureDone": "string",
      
              "medhpVaReportSize": "string",
      
              "medhpVaReportTemp": "string",
      
              "medhpVaReportWeight": "string",
      
              "reportDestination": "stri",
      
              "reportWay": "str",
      
              "staRecCode": "A",
      
              "medfiId": null
      
            }
      
          ],
      
          "MED_HOSP_SURGERY_REPORT": [
      
            {
      
              "createdTime": "17-09-2020 20:33",
      
              "modifiedTime": "17-09-2020 20:33",
      
              "createdUser": "Super",
      
              "modifiedUser": "Super",
      
              "medhpDtOpeReport": "10-09-2020 13:23",
      
              "medhpDtOpeReportBlocOutTime": "10-09-2020 13:23",
      
              "medhpDtOpeReportEnd": "10-09-2020 13:23",
      
              "medhpDtOpeReportExpectedExit": "10-09-2020 13:23",
      
              "medhpDtOpeReportExpectedTurnBack": "10-09-2020 13:23",
      
              "medhpDtOpeReportStart": "10-09-2020 13:23",
      
              "medhpId": 3,
      
              "medhpVaOpeReport": "string",
      
              "medhpVaOpeReportAnesthetist": "string",
      
              "medhpVaOpeReportAssistance": "string",
      
              "medhpVaOpeReportDiagnostic": "string",
      
              "medhpVaOpeReportExpectedDestination": "string",
      
              "medhpVaOpeReportNurseRoom": "string",
      
              "medhpVaOpeReportOperator": "string",
      
              "opeRepOpiId": "string",
      
              "staRecCode": "string",
      
              "medfiId": null
      
            }
      
          ]
      
        }
      })

  }

}